export default "__VITE_ASSET__DjqZCLrb__"